import { translateEvent } from "./mouseEvents";
export const setupHover = (targetElement, stage) => {
    let currentHoveredTarget = null;
    function handleNewHoveredNode(lastHoveredTarget, newHoveredTarget) {
        if (newHoveredTarget) {
            const cursorType = getCursorType(newHoveredTarget);
            targetElement.style.cursor = cursorType || "";
        }
    }
    function getCursorType(node) {
        if (node["cursor-type"]) {
            return node["cursor-type"];
        }
        else {
            const parent = node.getParentNode();
            if (parent) {
                return getCursorType(parent);
            }
            else {
                return undefined;
            }
        }
    }
    targetElement.addEventListener("mousemove", (e) => {
        const translatedEvent = translateEvent(stage, e);
        const newHoveredTarget = translatedEvent.target;
        if (newHoveredTarget !== currentHoveredTarget) {
            const lastHoveredTarget = currentHoveredTarget;
            currentHoveredTarget = newHoveredTarget;
            handleNewHoveredNode(lastHoveredTarget, newHoveredTarget);
        }
    });
};
//# sourceMappingURL=hover.js.map